import React, { useMemo } from "react";
import { map, max, min } from "lodash";
import { Locale } from "@linkfluence/models/locale";
import { Variant } from "./colors";
import Legend from "./legend";
import { GeoData, Mode, getCountFromMode } from "./model";

interface HoveredData {
  data: GeoData;
  event: mapboxgl.MapMouseEvent & mapboxgl.EventData;
}

export interface MapFooterProps {
  hoveredData: HoveredData;
  mode?: Mode;
  populations?: boolean;
  colors?: string[];
  variant?: Variant;
  data: any;
  locale: Locale;
}

export default function MapFooter({
  hoveredData,
  data,
  mode,
  populations,
  colors,
  variant,
  locale,
}: MapFooterProps) {
  const legend = useMemo(() => {
    const _data = map(data, (entry) => {
      return getCountFromMode(entry, mode, populations);
    });
    return {
      min: min(_data),
      max: max(_data),
      value: getCountFromMode(
        hoveredData ? hoveredData.data : null,
        mode,
        populations
      ),
    };
  }, [data, hoveredData, mode, populations]);
  return (
    <Legend
      colors={colors}
      variant={variant}
      value={legend.value}
      minValue={legend.min}
      maxValue={legend.max}
      locale={locale}
      populations={populations}
    />
  );
}
